<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>系统配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="广告推送配置" name="cache">
            <el-form class="demo-form-inline">
              <el-form-item label="firebase">
                <el-input v-model="formData.cache.firebase" style="width: 250px;" placeholder="Key" />
              </el-form-item>
              <el-form-item label="facebook">
                <el-input v-model="formData.cache.facebook" style="width: 250px;" placeholder="Value" />
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('cache')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="活动标题" name="title">
            <el-form class="demo-form-inline">
              <el-form-item :label="lang['EN']">
                <el-input v-model="formData.title.EN" style="width: 250px;" :placeholder="lang['EN']" />
              </el-form-item>
              <el-form-item :label="lang['ZH']">
                <el-input v-model="formData.title.ZH" style="width: 250px;" :placeholder="lang['ZH']" />
              </el-form-item>
              <el-form-item :label="lang['TW']">
                <el-input v-model="formData.title.TW" style="width: 250px;" :placeholder="lang['TW']" />
              </el-form-item>
              <el-form-item :label="lang['FR']">
                <el-input v-model="formData.title.FR" style="width: 250px;" :placeholder="lang['FR']" />
              </el-form-item>
              <el-form-item :label="lang['DE']">
                <el-input v-model="formData.title.DE" style="width: 250px;" :placeholder="lang['DE']" />
              </el-form-item>
              <el-form-item :label="lang['ES']">
                <el-input v-model="formData.title.ES" style="width: 250px;" :placeholder="lang['ES']" />
              </el-form-item>
              <el-form-item :label="lang['PT']">
                <el-input v-model="formData.title.PT" style="width: 250px;" :placeholder="lang['PT']" />
              </el-form-item>
              <el-form-item :label="lang['TH']">
                <el-input v-model="formData.title.TH" style="width: 250px;" :placeholder="lang['TH']" />
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('title')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="活动卡片" name="titleCard">
            <el-form class="demo-form-inline">
              <el-form-item :label="lang['EN']">
                <el-input v-model="formData.titleCard.EN" style="width: 250px;" :placeholder="lang['EN']" />
              </el-form-item>
              <el-form-item :label="lang['ZH']">
                <el-input v-model="formData.titleCard.ZH" style="width: 250px;" :placeholder="lang['ZH']" />
              </el-form-item>
              <el-form-item :label="lang['TW']">
                <el-input v-model="formData.titleCard.TW" style="width: 250px;" :placeholder="lang['TW']" />
              </el-form-item>
              <el-form-item :label="lang['FR']">
                <el-input v-model="formData.titleCard.FR" style="width: 250px;" :placeholder="lang['FR']" />
              </el-form-item>
              <el-form-item :label="lang['DE']">
                <el-input v-model="formData.titleCard.DE" style="width: 250px;" :placeholder="lang['DE']" />
              </el-form-item>
              <el-form-item :label="lang['ES']">
                <el-input v-model="formData.titleCard.ES" style="width: 250px;" :placeholder="lang['ES']" />
              </el-form-item>
              <el-form-item :label="lang['PT']">
                <el-input v-model="formData.titleCard.PT" style="width: 250px;" :placeholder="lang['PT']" />
              </el-form-item>
              <el-form-item :label="lang['TH']">
                <el-input v-model="formData.titleCard.TH" style="width: 250px;" :placeholder="lang['TH']" />
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('titleCard')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="推荐商品" name="recommend">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(r, i) in formData.recommend" :key="i">
                <el-form-item label="id">
                  <el-input v-model.number="r.id" style="width: 250px;" placeholder="id" />
                </el-form-item>
                <el-form-item label="名称">
                  <el-input v-model="r.name" style="width: 250px;" placeholder="名称" />
                </el-form-item>
                <el-form-item label="排序">
                  <el-input v-model.number="r.sort" style="width: 250px;" placeholder="排序" />
                </el-form-item>
                <el-form-item label="是否开启">
                  <el-select v-model.number="r.open" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button v-if="formData.recommend.length > 1" v-permisaction="['config:sysConfig:del']" type="danger" @click="removeRecommend(i)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="addRecommend()">+</el-button>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('recommend')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="礼品" name="openGiftPack">
            <el-form class="demo-form-inline">
              <el-form-item label="">
                <el-form-item label="打开礼品包">
                  <el-select v-model.number="formData.openGiftPack.openGiftPack" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:common-config:add']" type="primary" @click="onSubmit('openGiftPack')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="推送" name="push">
            <el-form class="demo-form-inline">
              <el-form-item label="推送等级">
                <el-input v-model="formData.push.downLevel" style="width: 250px;" placeholder="Key" />
              </el-form-item>
              <el-row v-for="(p, ii) in formData.push.push" :key="ii">
                <el-form :inline="true">
                  <el-form-item :label="lang[ii.toUpperCase()]">
                    <el-input v-model="p.title" style="width: 350px;" placeholder="标题" />
                  </el-form-item>
                  <el-form-item label="内容">
                    <el-input v-model="p.content" style="width: 700px;" placeholder="内容" />
                  </el-form-item>
                </el-form>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:common-config:add']" type="primary" @click="onSubmit('push')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="首冲" name="firstPay">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="等级范围">
                <el-input v-model="formData.firstPay.minLevelId" style="width: 250px;" placeholder="最小等级" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model="formData.firstPay.maxLevelId" style="width: 250px;" placeholder="最大等级" />
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('firstPay')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="疯狂加倍" name="crazyBet">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="体力">
                <el-input v-model.number="formData.crazyBet.spins" style="width: 250px;" placeholder="体力" />
              </el-form-item>
              <el-form-item label="次数">
                <el-input v-model.number="formData.crazyBet.times" style="width: 250px;" placeholder="次数" />
              </el-form-item>
              <el-form-item label="时间">
                <el-input v-model.number="formData.crazyBet.time" style="width: 250px;" placeholder="时间" />
              </el-form-item>
              <el-form-item label="间隔">
                <el-input v-model.number="formData.crazyBet.interval" style="width: 250px;" placeholder="间隔" />
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:common-config:add']" type="primary" @click="onSubmit('crazyBet')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="广告位" name="freeBar">
            <el-form class="demo-form-inline" :inline="true">
              <el-row v-for="(item, index) in formData.freeBar" :key="index">
                <el-form-item label="是否开启">
                  <el-select v-model.number="item.isOpen" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="间隔">
                  <el-input v-model.number="item.interval" style="width: 250px;" placeholder="次数" />
                </el-form-item>
                <el-form-item label="价格">
                  <el-select v-model.trim="item.price" placeholder="请选择" @change="v=>priceChange(v,index)">
                    <el-option
                      v-for="item in shopSku"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="margin-left: 16px;" @click="drawerArr[index].visible = true">奖励</el-button>
                  <el-drawer
                    title="我是标题"
                    :visible.sync="drawerArr[index].visible"
                    :with-header="false"
                    size="780px"
                  >
                    <el-form :inline="true">
                      <el-row v-for="(r,i) in item.reward" :key="i">
                        <el-form-item label="道具" style="margin-top: 10px;">
                          <el-select v-model.number="r.propsId" style="width: 130px;" placeholder="请选择">
                            <el-option
                              v-for="(item, index) in rewardType"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                        <el-form-item label="奖品数量" style="margin-top: 10px;">
                          <el-input v-model.number="r.num" style="width: 130px;" placeholder="奖品数量" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="金币取值">
                          <el-select v-model.number="r.rtype" :disabled="r.propsId !== 14" placeholder="请选择" style="width: 120px">
                            <el-option
                              v-for="item in selectType"
                              :key="item.id"
                              :label="item.title"
                              :value="item.id"
                            />
                          </el-select>
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;">
                          <el-button v-permisaction="['config:common-config:add']" type="danger" @click="removeReward(index,i)">删除</el-button>
                        </el-form-item>
                      </el-row>
                      <el-form-item style="margin-top: 10px;">
                        <el-button v-permisaction="['config:common-config:add']" type="primary" @click="addReward(index)">+</el-button>
                      </el-form-item>
                    </el-form>
                  </el-drawer>
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:common-config:add']" type="danger" @click="delFreeBar(index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-button v-permisaction="['config:common-config:add']" type="primary" @click="addFreeBar()">+</el-button>
              <el-button v-permisaction="['config:common-config:add']" type="primary" @click="onSubmit('freeBar')">保存</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="热更新配置" name="hotupdate">
            <el-form :inline="true" class="demo-form-inline">
              <el-row>
                <el-form-item label="安卓-版本">
                  <el-input v-model="formData.hotupdate.android.version" style="width: 250px;" placeholder="Key" />
                </el-form-item>
                <el-form-item label="是否强制更新">
                  <el-select v-model.number="formData.hotupdate.android.isForce" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="苹果-版本">
                  <el-input v-model="formData.hotupdate.ios.version" style="width: 250px;" placeholder="Key" />
                </el-form-item>
                <el-form-item label="是否强制更新">
                  <el-select v-model.number="formData.hotupdate.ios.isForce" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('hotupdate')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="游戏配置" name="Game">
            <el-form class="demo-form-inline">
              <el-form-item label="签到">
                <el-input v-model="formData.Game.signInDir" style="width: 250px;" placeholder="签到" />
              </el-form-item>
              <el-form-item label="豪华签到">
                <el-input v-model="formData.Game.superSignInDir" style="width: 250px;" placeholder="豪华签到" />
              </el-form-item>
              <el-form-item label="每日奖励 ICON">
                <el-input v-model="formData.Game.dailyReward" style="width: 250px;" placeholder="每日奖励 ICON" />
              </el-form-item>
              <el-form-item label="FB邀请奖励(体力)">
                <el-input v-model="formData.Game.inviteBindFBExtraReward" style="width: 250px;" placeholder="FB邀请奖励(体力)" />
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('Game')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="审核" name="IOSCheckStatus">
            <el-form class="demo-form-inline">
              <el-form-item label="Android审核">
                <el-select v-model.number="formData.AndroidCheckStatus.AndroidCheckStatus" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="IOS审核">
                <el-select v-model.number="formData.IOSCheckStatus.IOSCheckStatus" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button v-permisaction="['config:sysConfig:add']" type="primary" @click="onSubmit('IOSCheckStatus')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delBasicCfg, getSysCfg, updateCoinDozerCfg } from '@/api/config/sys-cfg'
import { getRewardType } from '@/api/config/slot'
import { getSku } from '@/api/config/shop-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'CommonConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      drawerArr: [{ visible: false }],
      activeName: 'cache',
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      lang: {
        'EN': '英 文',
        'ZH': '中 文',
        'TW': '繁 体',
        'FR': '法 语',
        'DE': '德 语',
        'ES': '西班牙',
        'PT': '葡萄牙',
        'TH': '泰 语',
        'VN': '越 南',
        'NO': '挪 威',
        'ID': '印 尼'
      },
      options: [{
        label: '开启',
        value: 1
      }, {
        label: '关闭',
        value: 0
      }],
      rewardType: [],
      shopSku: [],
      formData: {
        cache: { 'firebase': '3', 'facebook': '3' },
        title: { 'EN': 'Xmas', 'ZH': '圣诞节', 'TW': '聖誕節', 'FR': 'Noël', 'DE': 'Xmas', 'ES': 'Navidad', 'PT': 'Natal', 'TH': 'คริสต์มาส' },
        titleCard: { 'EN': 'Xmas\\ncard', 'ZH': '圣诞\\n卡片', 'TW': '聖誕\\n卡片', 'FR': 'Cartede\\nnoël', 'DE': 'Xmas\\ncard', 'ES': 'Tarjeta\\nNavidad', 'PT': 'Cartãode\\nnatal', 'TH': 'การ์ดคริสต์มาส' },
        recommend: [{
          'id': 1,
          'name': '推荐',
          'sort': 2,
          'open': 0
        }],
        model: 3,
        actSpinsLimit: 100,
        openGiftPack: 10,
        push: {
          downLevel: 1,
          push: {
            'en': {
              title: 'New worlds! Free Spins!',
              content: 'The whole new worlds have been opened for you! Now take up the challenge!'
            },
            'zh': {
              title: '\u65b0\u4e16\u754c\uff01 \u514d\u8d39\u80fd\u91cf\uff01',
              content: '\u5168\u65b0\u7684\u4e16\u754c\u5df2\u7ecf\u4e3a\u60a8\u6253\u5f00\uff01 \u73b0\u5728\u63a5\u53d7\u6311\u6218\uff01'
            },
            'tw': {
              title: '\u65b0\u4e16\u754c\uff01\u514d\u8cbb\u80fd\u91cf\uff01',
              content: '\u5168\u65b0\u7684\u4e16\u754c\u5df2\u7d93\u70ba\u60a8\u6253\u958b\uff01 \u73fe\u5728\u63a5\u53d7\u6311\u6230\uff01'
            },
            'fr': {
              title: 'De nouveaux mondes! Tours gratuits!',
              content: 'Les tout nouveaux mondes ont \u00e9t\u00e9 ouverts pour vous! Relevez maintenant le d\u00e9fi!'
            },
            'de': {
              title: 'Neue Welten! Freie Spins!',
              content: 'Die ganz neuen Welten haben sich f\u00fcr euch ge\u00f6ffnet! Jetzt nimm die Herausforderung an!'
            },
            es: {
              title: 'Nuevos mundos! \u00a1Tiradas gratis!',
              content: '\u00a1Se te han abierto mundos completamente nuevos! \u00a1Ahora acepta el desaf\u00edo!' },
            'pt': {
              title: 'Mundos novos! Rodadas Gr\u00e1tis!',
              content: 'Todo o novo mundo foi aberto para voc\u00ea! Agora aceite o desafio! ' },
            th: {
              title: '\u0e42\u0e25\u0e01\u0e43\u0e2b\u0e21\u0e48! \u0e2b\u0e21\u0e38\u0e19\u0e1f\u0e23\u0e35!',
              content: '\u0e42\u0e25\u0e01\u0e43\u0e2b\u0e21\u0e48\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14\u0e44\u0e14\u0e49\u0e40\u0e1b\u0e34\u0e14\u0e43\u0e2b\u0e49\u0e04\u0e38\u0e13! \u0e15\u0e2d\u0e19\u0e19\u0e35\u0e49\u0e23\u0e31\u0e1a\u0e04\u0e27\u0e32\u0e21\u0e17\u0e49\u0e32\u0e17\u0e32\u0e22!  '
            }
          }
        },
        firstPay: {
          minLevelId: 1,
          maxLevelId: 2
        },
        crazyBet: { spins: 1000000, times: 0, time: 10, interval: 30 },
        freeBar: [
          { isOpen: 0, price: 0, sku: '', interval: 86400, reward: [] }
        ],
        hotupdate: { 'android': { 'version': '1.8.1.2', 'isForce': 1 }, 'ios': { 'version': '1.8.1.2', 'isForce': 1 }},
        Game: { superSignInDir: '', signInDir: '', dailyReward: '', inviteBindFBExtraReward: 0 },
        IOSCheckStatus: {
          IOSCheckStatus: 0
        },
        AndroidCheckStatus: {
          AndroidCheckStatus: 0
        }
      }
    }
  },
  created() {
    this.getShopSkuList()
    this.getTables(this.activeName)
    this.getRewardTypeData()
  },
  methods: {
    add(name) {
      this.formData[name].push({
        item: name,
        title: '',
        content: '',
        memo: ''
      })
    },
    onSubmit(name) {
      let data = []
      if (name === 'openGiftPack') {
        data = this.formData[name].openGiftPack
      } else if (name === 'push') {
        updateCoinDozerCfg({ name: 'downLevel', data: this.formData.push.downLevel }).then(res => {
          if (res.code !== 200) {
            this.msgError(res.msg)
            return
          }
        })
        name = 'push'
        data = JSON.stringify(this.formData.push.push)
      } else if (name === 'firstPay') {
        updateCoinDozerCfg({ name: 'minLevelId', data: this.formData.firstPay.minLevelId }).then(res => {
          if (res.code !== 200) {
            this.msgError(res.msg)
            return
          }
        })
        name = 'maxLevelId'
        data = this.formData.firstPay.maxLevelId
      } else if (name === 'Game') {
        updateCoinDozerCfg({ name: 'signInDir', data: this.formData.Game.signInDir }).then(res => {
          if (res.code !== 200) {
            this.msgError(res.msg)
            return
          }
        })
        updateCoinDozerCfg({ name: 'superSignInDir', data: this.formData.Game.superSignInDir }).then(res => {
          if (res.code !== 200) {
            this.msgError(res.msg)
            return
          }
        })
        updateCoinDozerCfg({ name: 'inviteBindFBExtraReward', data: this.formData.Game.inviteBindFBExtraReward }).then(res => {
          if (res.code !== 200) {
            this.msgError(res.msg)
            return
          }
        })
        name = 'dailyReward'
        data = this.formData.Game.dailyReward
      } else if (name === 'IOSCheckStatus') {
        data = this.formData.IOSCheckStatus.IOSCheckStatus
        updateCoinDozerCfg({ name: 'AndroidCheckStatus', data: this.formData.AndroidCheckStatus.AndroidCheckStatus })
      } else {
        data = JSON.stringify(this.formData[name])
      }
      updateCoinDozerCfg({ name: name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(this.activeName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(name) {
      getSysCfg({ name: name }).then(res => {
        if (res.code === 200) {
          this.formData[name] = res.data
          if (name === 'freeBar') {
            res.data.forEach(res => {
              this.drawerArr.push({ visible: false })
            })
          }
          if (name === 'IOSCheckStatus') {
            getSysCfg({ name: 'AndroidCheckStatus' }).then(res => {
              this.formData['AndroidCheckStatus'] = res.data
              console.log(this.formData)
            })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getShopSkuList() {
      this.shopSku = [{ label: '免费', value: 0, sku: '' }]
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopSku.push({ label: val.price, value: val.price, sku: val.sku })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id, name) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBasicCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables(name)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    handleClick(tab, event) {
      console.log(tab.name, event)
      this.getTables(tab.name)
    },
    addRecommend() {
      const len = this.formData['recommend'].length + 1
      this.formData['recommend'].push({
        'id': len,
        'name': '推荐',
        'sort': len,
        'open': 0
      })
    },
    removeRecommend(i) {
      this.formData['recommend'] = this.formData['recommend'].filter((res, index) => {
        return i !== index
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(index) {
      this.formData.freeBar[index].reward.push({ 'propsId': 15, 'num': 0, rtype: 1 })
    },
    removeReward(index, i) {
      this.formData.freeBar[index].reward = this.formData.freeBar[index].reward.filter((res, key) => {
        return i !== key
      })
    },
    addFreeBar() {
      this.drawerArr.push({ visible: false })
      this.formData.freeBar.push({ isOpen: 0, price: 0, sku: '', interval: 86400, reward: [{ propsId: 15, num: 20 }] })
    },
    delFreeBar(i) {
      this.formData.freeBar = this.formData.freeBar.filter((res, index) => {
        return i !== index
      })
    },
    priceChange(v, index) {
      let sku = ''
      if (v === 0) {
        this.formData.freeBar[index].sku = ''
        return
      }
      for (const i in this.shopSku) {
        const val = this.shopSku[i]
        if (val.value === v) {
          sku = val.sku
          break
        }
      }

      if (!sku) {
        this.msgError('sku获取失败')
        return
      }

      console.log(sku)
      this.formData.freeBar[index].sku = sku
    }
  }
}
</script>

<style scoped>
</style>
